import { LoginResponse } from "../model/authentication";
import { apiSlice } from "../stores/base/api-slice";
import { resolveUtilityName } from "../tenant/branding/resolveTenant";
import { DeleteUserTeamMemberRequest, UpdateDetailsTeamMemberInvitationUserRequest, UserTeamMemberResponse, VerifyOtpTeamMemberInvitationRequest } from "./contract/team-management";

const teamManagementEndpoints = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAllTeamMembersForCustomer: builder.query<UserTeamMemberResponse[], string | void>({
      query: (data) => ({
        url: `/user/user-team-members/get-all-team-members${data !== undefined ? `?Search=${data.trim()}` : ''}`,
        method: 'GET',
      }),
      providesTags: ["TeamMembers"],
    }),
    newTeamMemberInvitation: builder.mutation<void, { email: string; firstName: string; lastName: string; roleId: string }>({
      invalidatesTags: ["TeamMembers"],
      query: (data) => ({
        url: `/user/user-team-members/invite-new-team-member`,
        method: 'POST',
        body: data,
      }),
    }),
    deleteUserTeamMember: builder.mutation<string, DeleteUserTeamMemberRequest>({
      invalidatesTags: ["TeamMembers"],
      query: (data) => ({
        url: `/user/user-team-members/delete-team-member`,
        method: 'DELETE',
        body: data,
      }),
    }),
    changeTeamMemberRole: builder.mutation<void, { userReferenceId: string; roleId: string }>({
      invalidatesTags: ["TeamMembers"],
      query: (data) => ({
        url: `/user/user-team-members/change-team-member-role`,
        method: 'PUT',
        body: data,
      }),
    }),
    getTeamMemberInviteById: builder.query<UserTeamMemberResponse, string>({
      query: (inviteId) => ({
        url: `/user/user-team-members/get-team-member-invite?InviteId=${inviteId}&utilityName=${resolveUtilityName()}`,
        method: 'GET',
      }),
    }),
    updateDetailsTeamMemberInvitation: builder.mutation<void, UpdateDetailsTeamMemberInvitationUserRequest>({
      invalidatesTags: ["TeamMembers"],
      query: (data) => ({
        url: `/user/user-team-members/update-details-team-member-invite`,
        method: 'POST',
        body: { ...data, utilityName: resolveUtilityName() },
      }),
    }),
    verifyOtpTeamMemberInvitation: builder.mutation<LoginResponse, VerifyOtpTeamMemberInvitationRequest>({
      invalidatesTags: ["TeamMembers"],
      query: (data) => ({
        url: `/user/user-team-members/verify-otp-team-member-invite`,
        method: 'POST',
        body: { ...data, utilityName: resolveUtilityName() },
      }),
    }),
  }),
});

export const {
  useGetAllTeamMembersForCustomerQuery,
  useLazyGetAllTeamMembersForCustomerQuery,
  useNewTeamMemberInvitationMutation,
  useDeleteUserTeamMemberMutation,
  useChangeTeamMemberRoleMutation,
  useLazyGetTeamMemberInviteByIdQuery,
  useUpdateDetailsTeamMemberInvitationMutation,
  useVerifyOtpTeamMemberInvitationMutation,
} = teamManagementEndpoints;